"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeNotificationTokens = void 0;
var normalizeNotificationTokens = function (_a) {
    var unscopeUser = _a.unscopeUser;
    var tokens = [];
    for (var _i = 0, _b = (unscopeUser === null || unscopeUser === void 0 ? void 0 : unscopeUser.notificationTokens) || []; _i < _b.length; _i++) {
        var notificationToken = _b[_i];
        if (typeof notificationToken !== 'string') {
            tokens.push(notificationToken);
        }
    }
    var _loop_1 = function (notificationToken) {
        if (typeof notificationToken === 'string') {
            var exist = tokens.find(function (_a) {
                var token = _a.token;
                return token === notificationToken;
            });
            if (!exist) {
                tokens.push({
                    token: notificationToken,
                    appName: undefined,
                });
            }
        }
    };
    for (var _c = 0, _d = (unscopeUser === null || unscopeUser === void 0 ? void 0 : unscopeUser.notificationTokens) || []; _c < _d.length; _c++) {
        var notificationToken = _d[_c];
        _loop_1(notificationToken);
    }
    return tokens;
};
exports.normalizeNotificationTokens = normalizeNotificationTokens;
